<template>
    <div>
        <form-wrapper>
            <form-cell width="two-thirds">
                <text-input
                    :formData="data"
                    :placeholder="$t('forms.offer.offer_filter.fields.term.placeholder')"
                    valuePath="searchFilter"
                    @input="inputChange($event)"
                ></text-input>
            </form-cell>
        </form-wrapper>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],

        props: {
            prefill: { type: Object, default: undefined },
        },

        data() {
            return {
                isEnterClicked: false,
                MIN_LENGTH: 2,
            }
        },

        methods: {
            inputChange(event) {
                const value = event.target.value
                if (value.length > this.MIN_LENGTH) {
                    this.serchResultChange(value)
                } else this.serchResultChange(null)
            },

            serchResultChange(value) {
                this.emitEvent({ name: 'search-category-change', payload: value })
            },
        },
    }
</script>
